// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1-HUK","disabled":"FileBtn_disabled__2kh8c","warn":"FileBtn_warn__2rVSV","fade":"FileBtn_fade__AO8IT"};